export default "__VITE_ASSET__XS5USqOG__"